import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from 'src/components/shared/Loading';
import { LoadingFailed } from 'src/components/shared/LoadingFailed';
import { RootState } from 'src/features';
import { actions } from 'src/features/fortune';
import { DialogRoute } from '../../shared/routes/DialogRoute';
import { FortunePageLayout } from '../common/FortunePageLayout';
import { FortuneHomeContent } from './FortuneHomeContent';
import { FortuneHomeErrorDialog } from './FortuneHomeErrorDialog';
import { FortuneHomeHintDialog } from './FortuneHomeHintDialog';

export const FortuneHome = () => {
  const { t } = useTranslation(['fortune', 'translation']);
  const point = useSelector((state: RootState) => state.fortune.point);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getTodaysFortune());
    return () => {
      dispatch(actions.clearUpdateStatus());
    };
  }, [dispatch]);

  return (
    <>
      <FortunePageLayout
        title={t('top')}
        backLabel={t('translation:aria_button_back_to_home')}
        hintPath="/players/fortune/home/hint"
        hintLabel={t('aria_help')}
      >
        {(() => {
          switch (point?.state) {
            case 'pending':
              return <Loading />;
            case 'ok':
              return <FortuneHomeContent pointResult={point.result} />;
            case 'error':
              return <LoadingFailed error={point.error} />;
            default:
              return <></>;
          }
        })()}
      </FortunePageLayout>

      <DialogRoute path="/players/fortune/home/hint">
        <FortuneHomeHintDialog />
      </DialogRoute>
      <DialogRoute path="/players/fortune/home/error">
        <FortuneHomeErrorDialog />
      </DialogRoute>
    </>
  );
};
